import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/live/topicSet',
    owner: '/home',
    authority: 'liveTopicSet',
    component: Loadable({
      loader: () => import('./mod'),
      loading: () => <RouteLoading />
    })
  },
];